// src/pages/OverTimeReport.js
import React, { useState, useEffect } from 'react';
import { Row, Col, Dropdown, Button, Form, ButtonGroup } from 'react-bootstrap';
import { FaMoneyBillAlt } from 'react-icons/fa';
import { CgProfile } from 'react-icons/cg';
import './overtime-report.css'; // Import the updated CSS file

// Number of rows per page
const defaultRowsPerPage = 10;
const rowsPerPageOptions = [5, 10, 15, 20];

// Dummy data
const mockOvertimeData = Array.from({ length: 50 }, (_, index) => ({
  id: index + 1,
  name: `Employee ${index + 1}`,
  hoursWorked: Math.floor(Math.random() * 100),
  overtimeRate: `$${(Math.random() * 50).toFixed(2)}`,
  overtimeHours: Math.floor(Math.random() * 20),
}));

export default function OverTimeReport() {
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(defaultRowsPerPage); // Initialize rowsPerPage state
  const [searchQuery, setSearchQuery] = useState(""); // State for search query

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      const startIndex = (currentPage - 1) * rowsPerPage;
      const endIndex = startIndex + rowsPerPage;
      setData(mockOvertimeData.slice(startIndex, endIndex));
      setLoading(false);
    }, 500); // Simulate a 0.5-second delay
  }, [currentPage, rowsPerPage]); // Added rowsPerPage to dependency array

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= Math.ceil(mockOvertimeData.length / rowsPerPage)) {
      setCurrentPage(pageNumber);
    }
  };

  const pageRange = () => {
    const pages = [];
    const totalPages = Math.ceil(mockOvertimeData.length / rowsPerPage);
    let startPage = Math.max(currentPage - 1, 1);
    let endPage = Math.min(startPage + 2, totalPages);

    if (endPage - startPage < 2) {
      startPage = Math.max(endPage - 2, 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  };

  return (
    <div>
      <h1 className="title-header">
        <FaMoneyBillAlt className="icon-spacing" /> My OverTime Report
      </h1>
      <hr />
      <h1 className="title-subheader">
        <CgProfile className="icon-spacing" /> Employee's Name
      </h1>
      <hr />
      <div className='table-container'>
        <div className="emp-info-actions">
          <Row>
            <Col xs={12} md={6} className="d-flex align-items-center">
              <Dropdown as={ButtonGroup}>
                <Button variant="primary" style={{ marginLeft: 0.5 }}>Show Entries</Button>
                <Dropdown.Toggle split variant="primary" id="dropdown-split-basic" />
                <Dropdown.Menu>
                  {rowsPerPageOptions.map(num => (
                    <Dropdown.Item key={num} onClick={() => setRowsPerPage(num)}>
                      {num}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </Col>
            <Col xs={12} md={6} className="d-flex justify-content-end">
              <div className="search-container">
                <Form className="d-flex">
                  <Form.Control
                    type="search"
                    placeholder="Search"
                    aria-label="Search"
                    className="emp-info-search"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                </Form>
              </div>
            </Col>
          </Row>
        </div>

        <div className="table-responsive">
          <table className="table table-striped custom-table">
            <thead className="overtime-table-header">
              <tr>
                <th>SR</th>
                <th>Name</th>
                <th>Hours Worked</th>
                <th>OverTime Rate</th>
                <th>OverTime Hours</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan="5" className='text-center'>Loading...</td></tr>
              ) : (
                data.length ? (
                  data.map(item => (
                    <tr key={item.id}>
                      <td>{item.id}</td>
                      <td>{item.name}</td>
                      <td>{item.hoursWorked}</td>
                      <td>{item.overtimeRate}</td>
                      <td>{item.overtimeHours}</td>
                    </tr>
                  ))
                ) : (
                  <tr><td colSpan="5" className='text-center'>No data Available Now</td></tr>
                )
              )}
            </tbody>
            <tfoot>
              <tr className='overtime-table-footer'>
                <td>Total</td>
                <td>-</td>
                <td>0</td>
                <td></td>
                <td></td>
              </tr>
            </tfoot>
          </table>
          <div className="containerrrr">
            <Row className="custom-row">
              <Col xs={12} md={9} className="custom-col-left">
                Showing {(currentPage - 1) * rowsPerPage + 1} to {Math.min(currentPage * rowsPerPage, mockOvertimeData.length)} of {mockOvertimeData.length} Entries
              </Col>
              <Col xs={12} md={3} className="custom-col-right">
                <nav>
                  <ul className="pagination">
                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                      <a
                        href="/#"
                        className="page-link"
                        onClick={(e) => {
                          e.preventDefault();
                          handlePageChange(currentPage - 1);
                        }}
                      >
                        Previous
                      </a>
                    </li>
                    {pageRange().map(pageNumber => (
                      <li key={pageNumber} className={`page-item ${currentPage === pageNumber ? 'active' : ''}`}>
                        <a
                          href="/#"
                          className="page-link"
                          onClick={(e) => {
                            e.preventDefault();
                            handlePageChange(pageNumber);
                          }}
                        >
                          {pageNumber}
                        </a>
                      </li>
                    ))}
                    <li className={`page-item ${currentPage === Math.ceil(mockOvertimeData.length / rowsPerPage) ? 'disabled' : ''}`}>
                      <a
                        href="/#"
                        className="page-link"
                        onClick={(e) => {
                          e.preventDefault();
                          handlePageChange(currentPage + 1);
                        }}
                      >
                        Next
                      </a>
                    </li>
                  </ul>
                </nav>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
}
